module.exports = __webpack_public_path__ + "static/media/5.cd8609bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/visual-electric/hero/5.png
// module id = 379
// module chunks = 0